import { useEffect, useState } from "react"

export default function useGanaConSears() {

    const [ trivias, setTrivias ] = useState()

    const dataGana = async () => {
        const apiURL = `https://www.sears.com.mx/medios-plazavip/swift/v1/staticJson/gana_con_sears.json`
        try {
            const config = {
                method: 'GET',
                timeout: 25,
            };
            const response = await fetch(apiURL, config)
            const data = await response.json();
            if(response?.status === 200){
                setTrivias(data)
                return data
            }
        } catch (error) {
            console.error('Error fetching getEventTable data:', error);
        }
    }

    useEffect(()=>{
        dataGana()
    },[])

    return{
        trivias
    }
}